<div class="deal-type-group">
  <div
    [ngClass]="formGroup?.get('selectedDealType')?.value==='finance' ? 'selected' : ''"
    (click)="changeDealType('finance')">
    Finance
  </div>
  <div
    [ngClass]="formGroup?.get('selectedDealType')?.value==='lease' ? 'selected' : ''"
    (click)="changeDealType('lease')">
    Lease
  </div>
  <div
    [ngClass]="formGroup?.get('selectedDealType')?.value==='cash' ? 'selected' : ''"
    (click)="changeDealType('cash')">
    Cash
  </div>
</div>
